"use client";

import { Button } from "@workspace/ui/components/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@workspace/ui/components/card";
import { signIn } from "next-auth/react";

const SignInPage = () => {
  return (
    <div className="relative h-s-full flex items-center flex-col bg-[#0A000B]">
      <div className="md:h-1/3 z-20 h-[46%] relative bg-[#0A000B] overflow-hidden object-cover  object-center w-full ">
        {/* <LogoAnimation /> */}
        <div className="top-0 h-full w-full absolute z-10 bg-linear-to-b  from-transparent to-[#0A000B] "></div>
      </div>
      <div className="absolute top-1/2 -translate-y-1/2 z-7777777">
        <div className="relative flex h-s-full items-center justify-center  animate-fade-in">
          <Card className="mx-auto w-md max-w-[400px] animate-item-1">
            <CardHeader className="text-center">
              <CardTitle className="text-3xl font-bold">Welcome</CardTitle>
              <CardDescription className="mt-2 text-lg">Sign in to access the Developer Platform</CardDescription>
            </CardHeader>
            <CardContent className="flex flex-col gap-4">
              <Button onClick={async () => await signIn("github", { callbackUrl: "/" })} variant="outline">
                <GithubIcon className="h-6 w-6" />
                Continue with GitHub
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default SignInPage;


function GithubIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4" />
      <path d="M9 18c-4.51 2-5-2-7-2" />
    </svg>
  );
}
